<div class="auction-end pb-5">
  <div class="bidder">
    <ng-container>
      <img src="assets/images/icons/auction-end.svg">
      <h2 class="title">{{"Auction Item.The auction has ended"|translate}}</h2>
      <h4 class="txt">{{"Auction Item.You're not the winning bidder"|translate}}</h4>
    </ng-container>
    <div class="last-bid">
      <p class="title">{{"Auction Item.Final Bid"|translate}}</p>
      <p class="price"> <span>{{"Auction Item.SR"|translate}}</span> {{lastPrice}}</p>
    </div>
  </div>
</div>